import React from 'react';
import { useLocation } from 'react-router-dom';

import { environment } from '../../environments/environment';
import analytics from './analytics.js';

export default function useGoogleAnalytics() {
  // biome-ignore lint/style/useConst: migrated from develop
  let location = useLocation();

  React.useEffect(() => {
    if (environment.production) analytics.init();
  }, []);

  React.useEffect(() => {
    if (environment.production) {
      const currentPath = location.pathname + location.search;
      if (currentPath !== '/') {
        analytics.sendPageview(currentPath);
      }
    }
  }, [location]);
}
